import React from "react";
import "../CSS/Services.css";
import { FaGraduationCap, FaUser, FaBuilding, FaSmile, FaFileAlt, FaHandshake, FaUsers } from "react-icons/fa";

const Services = () => {
  return (
    <section className="services-section">

      <h2 className="services-title">Our Services</h2>

      <div className="services-container">

        <div className="service-card">
          <FaGraduationCap className="service-icon"/>
          <h3>EDUCATIONAL</h3>
          <p>Document Apostille</p>
        </div>

        <div className="service-card">
          <FaUser className="service-icon"/>
          <h3>PERSONAL</h3>
          <p>Document Apostille</p>
        </div>

        <div className="service-card">
          <FaBuilding className="service-icon"/>
          <h3>COMMERCIAL</h3>
          <p>Document Apostille</p>
        </div>

      </div>


      {/* STATS SECTION */}

      <div className="stats-box">

        <div className="stat">
          <FaSmile className="stat-icon"/>
          <h3>11,2500</h3>
          <p>Happy Customers</p>
        </div>

        <div className="stat">
          <FaFileAlt className="stat-icon"/>
          <h3>32,4000</h3>
          <p>Documents Attested</p>
        </div>

        <div className="stat">
          <FaHandshake className="stat-icon"/>
          <h3>21,4877</h3>
          <p>Contracts Signed</p>
        </div>

        <div className="stat">
          <FaUsers className="stat-icon"/>
          <h3>4,105</h3>
          <p>Number of Visitors</p>
        </div>

      </div>

    </section>
  );
};

export default Services;